module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/kv_img-a5ceb2232ea946daa2023bde5222ba31.jpg";